import { render, staticRenderFns } from "./Susalud.vue?vue&type=template&id=257959b6&scoped=true"
import script from "./Susalud.vue?vue&type=script&lang=js"
export * from "./Susalud.vue?vue&type=script&lang=js"
import style0 from "./Susalud.vue?vue&type=style&index=0&id=257959b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257959b6",
  null
  
)

export default component.exports